/**
 * 字典管理
 */
import request from '@/utils/request'

const urlApi = {
  list: '/index/system/DictData/getList',
  add: '/index/system/DictData/add',
  edit: '/index/system/DictData/edit',
  del: '/index/system/DictData/del'
}

/**
 * 获取字典列表
 * @returns {*}
 */
export function dictDataList (parameter) {
  return request({
    url: urlApi.list,
    method: 'get',
    params: parameter
  })
}

/**
 * 添加字典
 * @returns {*}
 */
export function addDictData (parameter) {
  return request({
    url: urlApi.add,
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑字典
 * @returns {*}
 */
export function editDictData (parameter) {
  return request({
    url: urlApi.edit,
    method: 'post',
    data: parameter
  })
}

/**
 * 删除字典
 * parameter = {dict_id:0}
 * @returns {*}
 */
export function delDictData (parameter) {
  return request({
    url: urlApi.del,
    method: 'get',
    params: parameter
  })
}
